export default __webpack_public_path__ + "static/media/Cabezal.1b5af33e.jpg";